// removed by extract-text-webpack-plugin
module.exports = {"AddressBock":"src-layouts----Pages-module---AddressBock---1KhHS","Address":"src-layouts----Pages-module---Address---KDR6o","Cancellation":"src-layouts----Pages-module---Cancellation---ry8Zz","CancellationItem":"src-layouts----Pages-module---CancellationItem---2tIaP","AddressBockMap":"src-layouts----Pages-module---AddressBockMap---2XvyW"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Pages.module.css
// module id = 195
// module chunks = 70144966829960 182123141176091